import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'components/ui/use-toast';
import * as Api from '../api';

/** Codes the HTTP interceptor already turns into the upgrade dialog. */
const UPGRADE_CODES = new Set(['USAGE_LIMIT_EXCEEDED', 'FEATURE_NOT_ENTITLED']);

/** Copies a test in the active org as a new draft; resolves with the copy's id. */
const useDuplicate = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async ({ id, title }: { id: string; title?: string }) => (await Api.Duplicate(id, { title })).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['test', 'list'] });
      toast.success(t('tests.duplicated'));
    },
    onError: (error: unknown) => {
      const data = (error as { response?: { data?: { code?: string; message?: string } } })?.response?.data;
      if (data?.code && UPGRADE_CODES.has(data.code)) return;
      toast.error(t('tests.duplicate_failed'), { description: data?.message });
    },
  });
};

export default useDuplicate;
